import * as React from "react";
import { QuickJournalCyberpunkRain } from "./QuickJournalCyberpunkRain";
import * as styles from "./QuickJournalCyberpunkAmbientMotion.css";

const bokehLights = [
    { className: styles.streetBokehOne, hasReflection: true },
    { className: styles.streetBokehTwo, hasReflection: true },
    { className: styles.streetBokehThree, hasReflection: false },
    { className: styles.streetBokehFour, hasReflection: true },
    { className: styles.streetBokehFive, hasReflection: false },
    { className: styles.streetBokehSix, hasReflection: true },
    { className: styles.streetBokehSeven, hasReflection: false },
    { className: styles.streetBokehEight, hasReflection: true },
];

const rippleClassNames = [
    styles.streetRippleOne,
    styles.streetRippleTwo,
    styles.streetRippleThree,
];

const puddleClassNames = [
    styles.streetPuddleOne,
    styles.streetPuddleTwo,
    styles.streetPuddleThree,
    styles.streetPuddleFour,
    styles.streetPuddleFive,
    styles.streetPuddleSix,
];

export function QuickJournalCyberpunkAmbientMotion({
    isPaused = false,
}: {
    isPaused?: boolean;
}) {
    const animationPlayState: React.CSSProperties["animationPlayState"] =
        isPaused ? "paused" : "running";

    return (
        <div aria-hidden="true" className={styles.container}>
            <div
                className={`${styles.ambient} ${styles.ambientMagenta}`}
                style={{ animationPlayState }}
            />
            <div
                className={`${styles.ambient} ${styles.ambientCyan}`}
                style={{ animationPlayState }}
            />
            <div className={styles.wetStreet}>
                <div className={styles.streetSurface} />
                {puddleClassNames.map((puddleClassName) => (
                    <span
                        key={puddleClassName}
                        className={`${styles.streetPuddle} ${puddleClassName}`}
                        style={{ animationPlayState }}
                    />
                ))}
                {bokehLights.map(({ className, hasReflection }) => (
                    <span
                        key={className}
                        className={`${styles.streetBokeh} ${className} ${
                            hasReflection ? styles.streetBokehReflection : ""
                        }`}
                        style={{ animationPlayState }}
                    />
                ))}
                {rippleClassNames.map((rippleClassName) => (
                    <span
                        key={rippleClassName}
                        className={`${styles.streetRipple} ${rippleClassName}`}
                        style={{ animationPlayState }}
                    />
                ))}
            </div>
            <QuickJournalCyberpunkRain isPaused={isPaused} />
        </div>
    );
}
